//#region Imports and Global Definitions
import React, { useState, useEffect, } from 'react';
import { StyleSheet, SafeAreaView, Platform, useWindowDimensions, Image, ActivityIndicator } from 'react-native';
import { useTheme } from '@react-navigation/native';
import { createCommonStyles } from '../../../styles/commonStyles';
import CustomLabel from '../../../components/CustomLabel/CustomLabel';
import CustomInput from '../../../components/CustomInput';
import CustomButton from '../../../components/CustomButton';
import { useCompany } from '../../../hooks/useCompany';
import { showMessage } from "react-native-flash-message";
import CustomDropdown from "../../../components/CustomDropDown/CustomDropdown";
import * as ImagePicker from 'expo-image-picker';
import { Checkbox } from 'react-native-paper';
var _ = require('lodash');
import { useTranslation } from 'react-i18next';
import CustomText from '../../../components/CustomText/CustomText';
import { useSettingsContext } from '../../../hooks/useSettingsContext';
import CustomActivityIndicator from '../../../components/CustomActivityIndicator/CustomActivityIndicator';
//#endregion

const HRAdminEditCompanyScreen = (props) => {

    //#region Const Definitions
    const { width, height } = useWindowDimensions();
    const isPlatformWeb = (Platform.OS === 'web' && width > 992 ? false : true);
    const { colors } = useTheme();
    const styles = makeStyles(colors, width, height, isPlatformWeb);
    const common = createCommonStyles(colors);
    const [image, setImage] = useState("");
    const [currencies, setCurrencies] = useState([]);
    const { getCurrencies, getCompanyData, submitData, isLoading, isLoadingSecondary } = useCompany();
    const [companyData, setCompanyData] = useState({});
    const { t, i18n } = useTranslation();
    const [hasNotProvidedCode, setHasNotProvidedCode] = useState(false);
    const { d365 } = useSettingsContext();
    //#endregion

    //#region useEffect
    useEffect(() => {
        if (props.showNewCompanyScreen) {
            // * Initiate empty object when new company is created
            let newComp = {
                company: "",
                name: "",
                anotherLangName: "",
                legalName: "",
                currency: "",
                active: true,
                logo: "",
            };
            setCompanyData(newComp);
            showImage(newComp.logo);
        }
    }, [props.showNewCompanyScreen])

    useEffect(() => {
        if (props.selectedCompany) {
            getCompanyData(props.selectedCompany).then((data) => {
                let loadCompany = {
                    company: data?.company,
                    name: data?.name,
                    anotherLangName: data?.anotherLangName,
                    legalName: data?.legalName,
                    currency: data?.currency,
                    active: true,
                    logo: data?.logo ? data?.logo : "",
                };
                setCompanyData(loadCompany);
                showImage(loadCompany.logo);
            })
        }

        getCurrencies().then((curr) => {
            setCurrencies(curr)
        });

    }, [props.selectedCompany])
    //#endregion

    //#region Listeners
    const pickImage = async () => {
        let result = await ImagePicker.launchImageLibraryAsync({
            mediaTypes: ['images'],
            allowsEditing: false,
            quality: 0,
        });
        if (!result.canceled) {
            setImage(result.assets[0].uri);
            setCompanyData({
                ...companyData,
                logo: result.assets[0].uri.split(';base64,')[1]
            });
        }
    };

    const showImage = (photo) => {
        photo = 'data:image/jpeg;base64,' + photo;
        setImage(photo);
    };

    const setActiveCheckbox = () => {
        let tempComp = {
            company: companyData.company,
            name: companyData.name,
            anotherLangName: companyData.anotherLangName,
            legalName: companyData.legalName,
            currency: companyData.currency,
            active: !companyData.active,
            logo: companyData.logo
        };
        setCompanyData(tempComp)
    }

    const handleCurrencyChange = (currency) => {
        let tempComp = {
            company: companyData.company,
            name: companyData.name,
            anotherLangName: companyData.anotherLangName,
            legalName: companyData.legalName,
            currency: currency,
            active: companyData.active,
            logo: companyData.logo
        };
        setCompanyData(tempComp)
    }

    const handleCodeChange = (code) => {
        let tempComp = {
            company: code,
            name: companyData.name,
            anotherLangName: companyData.anotherLangName,
            legalName: companyData.legalName,
            currency: companyData.currency,
            active: companyData.active,
            logo: companyData.logo
        };
        setCompanyData(tempComp)
    }

    const handleNameChange = (name) => {
        let tempComp = {
            company: companyData.company,
            name: name,
            anotherLangName: companyData.anotherLangName,
            legalName: companyData.legalName,
            currency: companyData.currency,
            active: companyData.active,
            logo: companyData.logo
        };
        setCompanyData(tempComp)
    }

    const handleAnotherLanguageName = (anotherLangName) => {
        let tempComp = {
            company: companyData.company,
            name: companyData.name,
            anotherLangName: anotherLangName,
            legalName: companyData.legalName,
            currency: companyData.currency,
            active: companyData.active,
            logo: companyData.logo
        };
        setCompanyData(tempComp)
    }

    const handleLegalName = (legalName) => {
        let tempComp = {
            company: companyData.company,
            name: companyData.name,
            anotherLangName: companyData.anotherLangName,
            legalName: legalName,
            currency: companyData.currency,
            active: companyData.active,
            logo: companyData.logo
        };
        setCompanyData(tempComp)
    }

    const handleSave = () => {
        if (companyData.company === "") {
            setHasNotProvidedCode(true);
        }
        else {
            submitData(companyData, props.showNewCompanyScreen).then((response) => {
                showMessage({
                    message: response ? t("common:compSaveSucc") : t("common:compSaveFail"),
                    type: response ? "success" : "danger",
                    duration: 3000,
                });
            })
        }
    }
    //#endregion

    // * Loading Company Message
    if (isLoading) {
        return (
            <CustomActivityIndicator />
        )
    }

    return (
        <SafeAreaView style={styles.container}>
            <SafeAreaView style={styles.row}>
                <SafeAreaView style={[styles.compDetails, common.cardstyle]
                }>
                    <SafeAreaView style={[styles.row]}>
                        <CustomLabel
                            value={t("common:companyCode")}
                            type='COMPANY'
                        />
                        <CustomInput
                            editable={props.showNewCompanyScreen === 1 ? true : false}
                            value={companyData.company === undefined ? '' : companyData.company}
                            setValue={(e) => handleCodeChange(e)}
                            type='MAININPUT'
                            placeholder={t("common:companyCode")}
                        />
                        {hasNotProvidedCode
                            ? <CustomText style={styles.error}> *Required Field </CustomText>
                            : <></>
                        }
                    </SafeAreaView>
                    <SafeAreaView style={common.divider} />
                    <SafeAreaView style={[styles.row]}>
                        <CustomLabel
                            value={t("common:companyName")}
                            type='COMPANY'
                        />
                        <CustomInput
                            value={companyData.name === undefined ? '' : companyData.name}
                            setValue={(e) => handleNameChange(e)}
                            maxLen={50}
                            placeholder={t("common:companyName")}
                            type='MAININPUT'
                        />
                    </SafeAreaView>
                    <SafeAreaView style={common.divider} />
                    <SafeAreaView style={[styles.row]}>
                        <CustomLabel
                            value={t("common:companyName")}
                            type='COMPANY'
                        />
                        <CustomInput
                            value={companyData.anotherLangName === undefined ? '' : companyData.anotherLangName}
                            setValue={(e) => handleAnotherLanguageName(e)}
                            maxLen={50}
                            placeholder={t("common:companyName")}
                            type='MAININPUT'
                        />
                    </SafeAreaView>
                    <SafeAreaView style={common.divider} />
                    <SafeAreaView style={[styles.row]}>
                        <CustomLabel
                            value={t("common:companyLegalName")}
                            type='COMPANY'
                        />
                        <CustomInput
                            value={companyData.legalName === undefined ? '' : companyData.legalName}
                            setValue={(e) => handleLegalName(e)}
                            maxLen={50}
                            placeholder={t("common:companyLegalName")}
                            type='MAININPUT'
                        />
                    </SafeAreaView>
                    <SafeAreaView style={common.divider} />
                    <SafeAreaView style={[styles.row]}>
                        <CustomLabel
                            value={t("common:companyCurrency")}
                            type='COMPANY'
                        />
                        {isLoadingSecondary ? <ActivityIndicator animating={true} color={'#86BC25'} /> : <CustomDropdown
                            defValue={companyData.currency}
                            options={currencies}
                            value={companyData.currency}
                            setValue={(e) => handleCurrencyChange(e)}
                            type="MAININPUT"
                        />}
                    </SafeAreaView>
                    <SafeAreaView style={common.divider} />
                    {/* Not sure if this should be included */}
                    {/* <SafeAreaView style={[styles.row]}>
                            <View style={[{ flexShrink: 1, width: '19%' }, styles.label]}>
                                <CustomLabel
                                    value="Employee Retention Period"
                                />
                            </View>
                            <View style={[styles.smallInputBox, { marginLeft: '4%' }]}>
                                <CustomDropdown
                                    disabled={false}
                                    // defValue={selectedWorkflow}
                                    options={items}
                                // value={selectedWorkflow}
                                // setValue={(e) => handleWorkflowChange(e)}
                                type="NEW_COMPANY"
                                />
                            </View>
                        </SafeAreaView> */}
                    <SafeAreaView style={[styles.row]}>
                        <CustomLabel
                            value={t("common:companyActve")}
                            type='COMPANY'
                        />
                        <Checkbox
                            status={companyData.active ? 'checked' : 'unchecked'}
                            onPress={() => setActiveCheckbox()}
                        />
                    </SafeAreaView>
                </SafeAreaView>
                {/* //* Logo flex 1 view but hard coded size  */}
                <SafeAreaView style={[styles.compLogo]}>
                    <SafeAreaView style={[styles.compLogoTitle]}>
                        <CustomLabel
                            value={t("common:companyLogo")}
                            type='COMPANY'
                        />
                        <CustomLabel
                            value={t("common:companyLogoSub")}
                            type='MINORTITLE_MUTED'
                        />
                    </SafeAreaView>
                    <Image source={{ uri: 'data:image/jpeg;base64,' + companyData.logo }} resizeMode='contain' style={{ width: 400, height: 400 }} />
                </SafeAreaView>
            </SafeAreaView>
            <SafeAreaView style={common.divider} />
            <SafeAreaView style={styles.cardstyle}>
                <CustomButton
                    text={t('common:addCompanyLogo')}
                    onPress={() => pickImage()}
                    iconName="add-outline"
                    show="BUTTON_ADD"
                    type="BUTTON_ADD"
                    textTop="0"
                    sz={20}
                />
                <CustomButton
                    text={t('common:save')}
                    onPress={() => handleSave()}
                    iconName="save-outline"
                    show="BUTTON_SAVE"
                    type="BUTTON_SAVE"
                    textTop="0"
                    isGradient={true}
                    sz={20}
                />
            </SafeAreaView>
        </SafeAreaView >

    )
};

//#region Styles
const makeStyles = (colors, width) => StyleSheet.create({
    container: {
        flex: 1,
    },
    row: {
        flex: 1,
        flexDirection: "row",
        alignItems: 'center',
        margin: 5,
    },
    compDetails: {
        paddingHorizontal: 0,
        flex: 2,
    },
    compLogo: {
        flex: 1,
        alignItems: 'center',
    },
    compLogoTitle: {
        width: '100%',
    },
    smallInputBox: {
        flex: 1,
        margin: 10,
    },
    cardstyle: {
        padding: 10,
        width: "100%",
        flexDirection: "row",
        justifyContent: "flex-end",
        color: colors.background
    },
    error: {
        color: colors.validation_error,
        alignSelf: 'center',
        fontSize: 14,
    },

});


//#endregion

export default HRAdminEditCompanyScreen;